var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DateRangeFilter',{attrs:{"title":_vm.facet.title,"optionSet":_vm.optionSet},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})
}
var staticRenderFns = []

export { render, staticRenderFns }